module.exports = __webpack_public_path__ + "static/media/STVid2.9b383140.mp4";